import DocumentHeader from '@components/DocumentHeader';
import { NotFoundPageWrapper, SubHeading, Links } from './styled';
import { Column, Row } from '@simplywallst/ui-core';
import { RouterLink } from '@redux-first-router-link';
import {
  ROUTE_STOCKS_HOME,
  ROUTE_DISCOVER_INVESTING_IDEAS,
  ROUTE_DISCOVER_SAMPLE_PORTFOLIOS,
} from '@/constants/routes';
import { SWS_SUPPORT } from '@/constants';
import { SUPPORT_EMAIL } from '@/constants';
import GlobalStyle from '@/styled/styled.default';
import { useHomeRoute } from '@/hooks/useHomeRoute';

const NotFound = () => {
  const homeRoute = useHomeRoute();
  return (
    <NotFoundPageWrapper>
      <GlobalStyle />
      <DocumentHeader title={'Page Not Found'} />
      <Column displayFlex column justifyContent="center" alignItem="center">
        <Row>
          <h2>Sorry, the page you&apos;re looking for was not found.</h2>
        </Row>
        <Row>
          <SubHeading>Here are some helpful links instead</SubHeading>
        </Row>
        <Row>
          <Links>
            {/* Routes linked to here must be defined with a specific state side effect in reducers/page.ts, */}
            {/* otherwise they will fail to correctly navigate. */}
            <li>
              <RouterLink to={{ type: homeRoute }} data-cy-id="home">
                Home
              </RouterLink>
            </li>
            <li>
              <RouterLink
                to={{ type: ROUTE_STOCKS_HOME }}
                data-cy-id="browse-companies"
              >
                Browse for companies
              </RouterLink>
            </li>
            <li>
              <RouterLink
                to={{ type: ROUTE_DISCOVER_SAMPLE_PORTFOLIOS }}
                data-cy-id="browse-portfolios"
              >
                Browse sample portfolios
              </RouterLink>
            </li>
            <li>
              <RouterLink
                to={{ type: ROUTE_DISCOVER_INVESTING_IDEAS }}
                data-cy-id="browse-investingideas"
              >
                Discover investing ideas
              </RouterLink>
            </li>
            <li>
              <a href={SWS_SUPPORT}>Learning centre</a>
            </li>
          </Links>
        </Row>
        <Row>
          <p>
            <span>If you think you're seeing this page in error </span>
            <a href={SUPPORT_EMAIL} rel="nofollow">
              send us an email
            </a>
            <span> to let us know!</span>
          </p>
        </Row>
      </Column>
    </NotFoundPageWrapper>
  );
};

export default NotFound;
